export const en ={
  "login_for_quick_quote": "Easy, fast, safe.",
  "origin": "Origin",
  "payment_details": "Payment Options",
  "postal_code": "Zip Code USA",
  "for": "For",
  "enter_city_final_destination": "Enter city final destination",
  "continue": "Continue",
  "close_session": "Close Session",
  "english": "English",
  "spanish": "Spanish",
  "large": "Large",
  "dimensions": "Dimensions",
  "length": "Length",
  "high": "Hight",
  "width": "Wide",
  "weight": "Weight",
  "declared_value": "Declared Value",
  "cancel": "Cancel",
  "tell_us_more_about_your_shipment": "Tell us more about your shipment",
  "inches_or_centimeters": "Inches or centimeters",
  "pounds_or_kilograms": "Pounds or kilograms",
  "use_the_format_you_need": "Use the format you need",
  "if_you_have_questions": "If you have questions",
  "measurement_guide": "Measurement guide",
  "box_size": "Box Size",
  "envelope": "Envelope",
  "small_box": "Small Box",
  "medium_box": "Medium Box",
  "large_box": "Large Box",
  "inches": "Inches",
  "payment_method": "Payment Method",
  "use": "Use",
  "sender_name": "Sender Name",
  "phone_number": "Phone Number",
  "address": "Address",
  "instructions": "Instructions",
  "save": "Save",
  "contact_us": "Contact us",
  "destination_name": "Recipient Name",
  "remitent_name": "Sender Name",
  "neighborhood": "Neighborhood",
  "Indications": "Instructions",
  "return": "Return",
  "add_address": "Add address",
  "loading": "Loading...",
  "edit_measures": "Edit size",
  "delivery_options": "Choose your shipping speed",
  "day": "Day",
  "days": "Days",
  "unexpected_error_message": "An unexpected error occurred, try again",
  "fee_change": "Fee change",
  "login_register_seconds": "Sign in for a quick quote.",
  "to_qoute_shipment": "To quote your shipment",
  "login_methods": "Login with social networks will soon be available.",
  "password": "Password",
  "login": "Log in",
  "sing_up": "Register",
  "forget_password": "Forgot password",
  "or": "or",
  "logout": "Log out",
  "measurementGuide": "Common sizes and weights",
  "paper_envelope": "Paper envelope",
  "inch": "inch",
  "broad": "Wide",
  "long": "Long",
  "max_largebox": "(max 80lbs or 40kg)",
  "medium_box_max": "(max 50lbs or 25kg)",
  "small_box_max": "(max 25lbs or 13kg)",
  "pay_with_credit_card": "Pay with credit card",
  "pay_with_zelle": "Pay with Zelle",
  "pay": "Pay",
  "delivery_summary": "Delivery Summary",
  "remitent_data": "Sender",
  "destination_data": "Recipient data in Colombia",
  "tell_more_about_us": "Tell us more about your shipment. ",
  "please_enter_the_size": "Please enter the size and weight of the shipment. You can use inches or centimeters for dimensions and pounds or kilograms for weight. Use the format you need.",
  "measurement_format": "Measurement format",
  "value_of_the_merchandise": "Value of the merchandise",
  "centimeters": "Centimeters",
  "there_are_an_error": "There was an error",
  "success_payment": "Successful payment",
  "remitent": "Sender",
  "destination": "Final destination",
  "download_guide": "Download guide",
  "whats_next": "What's next?",
  "important_note": "IMPORTANT NOTE: ",
  "the_zelle_services": "The Zelle service allows you to send money using an email. We prefer this option as it minimizes the possibility of sending the payment to the wrong number.",
  "zelle_indiacions_1": "Please copy and paste the following email in the Zelle application as shown to avoid delays:",
  "just_reference": "Just for your reference: The registered name is ",
  "advanced_consulting_business": "Advanced Consulting Business.",
  "contact_by_whatsapp": " After making the payment, contact us through our WhatsApp:",
  "in_order_to_send_guide": "to send you your guide, which must be wrapped in clear tape.",
  "last_step": "Last step:",
  "delivery_your_box": "Deliver your box to the corresponding carrier.",
  "warning": "Warning:",
  "box_that_are_more_than": "Boxes weighing more than 40 pounds (20 kilograms) must be wrapped in plastic or tape to prevent them from opening at any edge.",
  "From": "From (State)",
  "to": "To",
  "shipping_around_usa": "Shipping within the USA",
  "shipping_from": "International shipping from Florida",
  "tax": " Customs tax value",
  "delivery_time": "Delivery time (Business days)",
  "provider": "Provider within the USA",
  "Total": "Total",
  "cost_of_shiping": "Shipping cost",
  "insurance_and_taxes":"Taxes and insurance",
  "freight":"Freight",
  "incorrect_password":"Your account exists, but your password is incorrect. Use the same password as on app.latamshipping.com.",
  "origen_destino":"From & To",
  "cost":"Cost",
  "print_your_guide":"Imprime tu guía y asegúrate de que esté completamente forrada con cinta plástica. Luego, entrega tu caja a la transportadora correspondiente.",
  'deliver_your_box_to':'Deliver your box to:',
  'no_result': 'Results not found',
  "adress_data_error": "one or more fields on the new Address are not correct, please try again",
  "city": "City",
  "select": "Choose one",
  "cheapest": "Cheapest",
};